var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showGuideModal,
          expression: "showGuideModal",
        },
      ],
      staticClass: "guide_modal",
    },
    [
      _c("div", { staticClass: "guide_overlay" }),
      _c("div", { staticClass: "guide_modal_position" }, [
        _c(
          "div",
          { staticClass: "guide_modal-card" },
          [
            _c(
              "div",
              {
                staticClass:
                  "guide_modal_title d-flex justify-content-between align-items-center",
              },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("modal.guide.title")))]),
                _c(
                  "div",
                  { staticClass: "close_modal", on: { click: _vm.closeModal } },
                  [
                    _c("img", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        src: `${_vm.$s3}/img/common/guideModal/close.svg?${this.$ver}`,
                      },
                    }),
                  ]
                ),
              ]
            ),
            _c("div", { staticClass: "guide_modal_layout" }, [
              _c(
                "div",
                {
                  staticClass: "d-grid align-items-center",
                  staticStyle: { overflow: "auto" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "guide_modal-card_web",
                      staticStyle: { margin: "10px" },
                    },
                    [
                      _c("img", {
                        staticClass: "w-100",
                        staticStyle: { "pointer-events": "none" },
                        attrs: {
                          src: `${_vm.$s3}/img/common/guideModal/guide_1_${_vm.lang}.webp?${_vm.$ver}`,
                        },
                      }),
                      _c("div", [
                        _c("div", {
                          staticClass: "guide_modal_content_title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("modal.guide.card.title")),
                          },
                        }),
                        _c("img", {
                          staticStyle: { "pointer-events": "none" },
                          attrs: {
                            src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "guide_modal_content_content" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card.content"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card.content1"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card.content2"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "guide_modal-card_web",
                      staticStyle: { margin: "10px" },
                    },
                    [
                      _c("img", {
                        staticClass: "w-100",
                        staticStyle: { "pointer-events": "none" },
                        attrs: {
                          src: `${_vm.$s3}/img/common/guideModal/guide_2_${_vm.lang}.webp?${_vm.$ver}`,
                        },
                      }),
                      _c("div", [
                        _c("div", {
                          staticClass: "guide_modal_content_title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("modal.guide.card2.title")
                            ),
                          },
                        }),
                        _c("img", {
                          staticStyle: { "pointer-events": "none" },
                          attrs: {
                            src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "guide_modal_content_content" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card2.content"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card2.content1"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card2.content2"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "guide_modal-card_web",
                      staticStyle: { margin: "10px" },
                    },
                    [
                      _c("img", {
                        staticClass: "w-100",
                        staticStyle: { "pointer-events": "none" },
                        attrs: {
                          src: `${_vm.$s3}/img/common/guideModal/guide_3_${_vm.lang}.webp?${_vm.$ver}`,
                        },
                      }),
                      _c("div", [
                        _c("div", {
                          staticClass: "guide_modal_content_title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("modal.guide.card3.title")
                            ),
                          },
                        }),
                        _c("img", {
                          staticStyle: { "pointer-events": "none" },
                          attrs: {
                            src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "guide_modal_content_content" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card3.content"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card3.content1"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "guide_modal-card_web",
                      staticStyle: { margin: "10px" },
                    },
                    [
                      _c("img", {
                        staticClass: "w-100",
                        staticStyle: { "pointer-events": "none" },
                        attrs: {
                          src: `${_vm.$s3}/img/common/guideModal/guide_4_${_vm.lang}.webp?${_vm.$ver}`,
                        },
                      }),
                      _c("div", [
                        _c("div", {
                          staticClass: "guide_modal_content_title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("modal.guide.card4.title")
                            ),
                          },
                        }),
                        _c("img", {
                          staticStyle: { "pointer-events": "none" },
                          attrs: {
                            src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "guide_modal_content_content" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card4.content"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card4.content3"))
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("modal.guide.card4.content4"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c(
              "Flicking",
              {
                attrs: { options: { circular: true }, plugins: _vm.plugin },
                scopedSlots: _vm._u([
                  {
                    key: "viewport",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "flicking-pagination mb-1" }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("div", { staticClass: "guide_modal-card_mobile" }, [
                  _c("img", {
                    staticClass: "w-100",
                    staticStyle: { "pointer-events": "none" },
                    attrs: {
                      src: `${_vm.$s3}/img/common/guideModal/guide_1_${_vm.lang}.webp?${_vm.$ver}`,
                    },
                  }),
                  _c("div", [
                    _c("div", {
                      staticClass: "guide_modal_content_title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("modal.guide.card.title")),
                      },
                    }),
                    _c("img", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                      },
                    }),
                    _c("div", { staticClass: "guide_modal_content_content" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card.content"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card.content1"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card.content2"))),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "guide_modal-card_mobile" }, [
                  _c("img", {
                    staticClass: "w-100",
                    staticStyle: { "pointer-events": "none" },
                    attrs: {
                      src: `${_vm.$s3}/img/common/guideModal/guide_bottom_sheet_${_vm.lang}.webp?${_vm.$ver}`,
                    },
                  }),
                  _c("div", [
                    _c("div", {
                      staticClass: "guide_modal_content_title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("modal.guide.card1.title")),
                      },
                    }),
                    _c("img", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                      },
                    }),
                    _c("div", { staticClass: "guide_modal_content_content" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card1.content"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card1.content1"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card1.content2"))),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "guide_modal-card_mobile" }, [
                  _c("img", {
                    staticClass: "w-100",
                    staticStyle: { "pointer-events": "none" },
                    attrs: {
                      src: `${_vm.$s3}/img/common/guideModal/guide_2_${_vm.lang}_mobile.webp?${_vm.$ver}`,
                    },
                  }),
                  _c("div", [
                    _c("div", {
                      staticClass: "guide_modal_content_title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("modal.guide.card2.title")),
                      },
                    }),
                    _c("img", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                      },
                    }),
                    _c("div", { staticClass: "guide_modal_content_content" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card2.content"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card2.content1"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card2.content2"))),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "guide_modal-card_mobile" }, [
                  _c("img", {
                    staticClass: "w-100",
                    staticStyle: { "pointer-events": "none" },
                    attrs: {
                      src: `${_vm.$s3}/img/common/guideModal/guide_3_${_vm.lang}.webp?${_vm.$ver}`,
                    },
                  }),
                  _c("div", [
                    _c("div", {
                      staticClass: "guide_modal_content_title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("modal.guide.card3.title")),
                      },
                    }),
                    _c("img", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                      },
                    }),
                    _c("div", { staticClass: "guide_modal_content_content" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card3.content"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card3.content1"))),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "guide_modal-card_mobile" }, [
                  _c("img", {
                    staticClass: "w-100",
                    staticStyle: { "pointer-events": "none" },
                    attrs: {
                      src: `${_vm.$s3}/img/common/guideModal/guide_4_${_vm.lang}.webp?${_vm.$ver}`,
                    },
                  }),
                  _c("div", [
                    _c("div", {
                      staticClass: "guide_modal_content_title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("modal.guide.card4.title")),
                      },
                    }),
                    _c("img", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        src: `${_vm.$s3}/img/common/guideModal/bulb.svg?${_vm.$ver}`,
                      },
                    }),
                    _c("div", { staticClass: "guide_modal_content_content" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card4.content"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card4.content3"))),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("modal.guide.card4.content4"))),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }